(function () {
  'use strict';
  /* Switch the loading shimmer off once an image has loaded. The shimmer itself is pure CSS (bg-skeleton.css). */
  var WRAPPERS = '.product-featured-image, .collection-link-card__image, .std-gallery__slide, .std-thumb, .std-pair__media, .sqv-media, .bgc-item__media, .bgc-rec__media, .bgb-tile__media, .bgA-hero, .featured-image.aspect-ratio';
  function done(wrap) { wrap.classList.add('bg-skel-done'); }
  function watch(wrap) {
    if (wrap.__skel) return;
    wrap.__skel = true;
    var img = wrap.querySelector('img');
    if (!img) { done(wrap); return; }
    if (img.complete && img.naturalWidth > 0) { done(wrap); return; }
    img.addEventListener('load', function () { done(wrap); }, { once: true });
    img.addEventListener('error', function () { done(wrap); }, { once: true });
  }
  function scan(root) { (root || document).querySelectorAll(WRAPPERS).forEach(watch); }
  scan();
  new MutationObserver(function (records) {
    records.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches(WRAPPERS)) watch(n); scan(n); } }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
